<template>
    <div>
        <navbar1></navbar1>
        <div class="__outsourcebg">
            <div class="container">
                <div class="row">
                    <div class="col-lg-7 col-md-9 col-sm-9">
                        <!-- <p class="__welf1">Outsource your engineering team with us</p> -->
                        <p class="__welf1">Hire from our network<br> of pre-vetted tech talents</p>
                        <p class="__welf2">Fill the form below and we will reach you shortly</p>
                    </div>
                    <div class="col-lg-5 col-md-3 col-sm-3"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="__form-wrap ">
                <div class="row ">
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <p class="__number">
                        10,000+
                        </p>
                        <p>
                        Active members on the <br />
                        saucecode community.
                        </p>

                        <p class="__number">
                        510+
                        </p>
                        <p>
                        Number of professionals in <br />
                        our PRO network.
                        </p>

                        <p class="__number">
                        120+
                        </p>
                        <p>
                        Number of hired developers <br />
                        and designers.
                        </p>
                    </div>
                    <div class="col-lg-8 col-md-8 col-sm-8">
                        <p class="__hirep">
                        Let us know you
                        </p>

                        <p class="__hirep1">We charge N30,000 i.e $30 as commitment fee and 10% of the talent’s annual salary.</p>

                        <a href="https://paystack.com/pay/4dra80v73y" class="btn __adjustlink ">Proceed to pay the commitment fee</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import navbar1 from "../components/navbar1";
export default {
  components: { navbar1 },
}
</script>

<style scoped>
@import '../assets/css/talent';


</style>



// WEBPACK FOOTER //
// src/components/payment.vue